import { useModal } from '@ebay/nice-modal-react';
import Button from '@shared/components/Button/Button';
import { useTranslation } from 'react-i18next';

import { ReactComponent as UserPlus } from 'assets/icons/UserPlus.svg';
import CreateWorkspaceModal from 'modules/CreateWorkspaceModal/CreateWorkspaceModal';
import { CreateWorkspaceMode, CreateWorkspaceStepsEnum } from 'modules/CreateWorkspaceModal/types';
import SettingsCard from 'modules/SettingsModal/SettingsCard/SettingsCard';
import useWorkspacesContext from 'modules/Workspaces/WorkspacesProvider/useWorkspacesContext';

const InvitePeopleSection = () => {
  const { t } = useTranslation();
  const { workspaceId } = useWorkspacesContext({ requireWorkspaceId: true });
  const createWorkspaceModal = useModal(CreateWorkspaceModal);

  const handleInviteClick = () => {
    createWorkspaceModal.show({
      parentWorkspaceId: null,
      initialStep: CreateWorkspaceStepsEnum.INVITE,
      initialWorkspaceId: workspaceId,
      mode: CreateWorkspaceMode.INVITE_ONLY,
    });
  };

  return (
    <SettingsCard>
      <div className="w-full h-full p-4 space-y-4">
        <div className="space-y-1">
          <p className="text-size-sm font-medium text-black">{t('people')}</p>
          <p className="text-size-sm text-gray-80">{t('workspaces.invite_people_desc')}</p>
        </div>
        <Button
          variant="primary"
          size="sm"
          iconRight={{ icon: UserPlus, className: 'w-5 h-5 stroke-current stroke-1.5' }}
          onClick={handleInviteClick}
          className="w-full md:w-auto"
        >
          {t('workspaces.invite_people')}
        </Button>
      </div>
    </SettingsCard>
  );
};

export default InvitePeopleSection;
